const features = [
  {
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <polygon points="13,2 3,14 12,14 11,22 21,10 12,10" />
      </svg>
    ),
    title: 'Instant Delivery',
    description:
      'OTP codes arrive in your dashboard within 3 seconds of request. Our global infrastructure guarantees speed at scale.',
    color: '#3B82F6',
    lightBg: '#EFF6FF',
    border: '#BFDBFE',
  },
  {
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    ),
    title: 'Global Numbers',
    description:
      '150+ country codes with local phone numbers that pass every carrier validation check, every single time.',
    color: '#6366F1',
    lightBg: '#EEF2FF',
    border: '#C7D2FE',
  },
  {
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    title: 'Total Privacy',
    description:
      'Never expose your real number online. Each virtual number is disposable and never linked to your identity.',
    color: '#10B981',
    lightBg: '#F0FDF4',
    border: '#A7F3D0',
  },
  {
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <polyline points="23,6 13.5,15.5 8.5,10.5 1,18" />
        <polyline points="17,6 23,6 23,12" />
      </svg>
    ),
    title: '99.8% Success Rate',
    description:
      'Our premium carrier network routes through tier-1 operators, delivering unmatched verification reliability.',
    color: '#F59E0B',
    lightBg: '#FFFBEB',
    border: '#FDE68A',
  },
  {
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    ),
    title: 'Pay-Per-Use',
    description:
      'No subscriptions, no monthly fees. Numbers from $0.03. Only pay for the verifications you actually need.',
    color: '#0EA5E9',
    lightBg: '#F0F9FF',
    border: '#BAE6FD',
  },
  {
    icon: (
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    ),
    title: 'End-to-End Encrypted',
    description:
      'All SMS traffic is encrypted in transit and at rest. Your verification history is yours alone — zero data sales.',
    color: '#EF4444',
    lightBg: '#FFF1F2',
    border: '#FECDD3',
  },
]

export function Features() {
  return (
    <section
      id="features"
      style={{ padding: '120px 24px', maxWidth: '1200px', margin: '0 auto' }}
    >
      <div style={{ textAlign: 'center', marginBottom: '64px' }}>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: '#F0FDF4',
            border: '1px solid #A7F3D0',
            borderRadius: '100px',
            padding: '6px 16px',
            marginBottom: '20px',
          }}
        >
          <span
            style={{
              fontSize: '12px',
              letterSpacing: '0.5px',
              color: '#10B981',
              fontWeight: '600',
            }}
          >
            Why GetCode
          </span>
        </div>
        <h2
          style={{
            fontSize: 'clamp(28px, 3.5vw, 46px)',
            fontWeight: '800',
            letterSpacing: '-1px',
            color: '#0F172A',
            margin: '0 0 16px',
          }}
        >
          Built for speed,{' '}
          <span
            style={{
              background: 'linear-gradient(135deg, #10B981, #3B82F6)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            designed for privacy
          </span>
        </h2>
        <p
          style={{
            fontSize: '17px',
            color: '#6B7280',
            maxWidth: '480px',
            margin: '0 auto',
          }}
        >
          Every feature is purpose-built to make SMS verification seamless,
          safe, and affordable.
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          gap: '18px',
        }}
      >
        {features.map((feature, i) => (
          <div
            key={i}
            style={{
              background: 'white',
              border: `1.5px solid ${feature.border}`,
              borderRadius: '20px',
              padding: '32px',
              transition: 'all 0.3s ease',
              cursor: 'default',
              position: 'relative',
              overflow: 'hidden',
              boxShadow: '0 1px 6px rgba(0,0,0,0.04)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-4px)'
              e.currentTarget.style.borderColor = feature.color
              e.currentTarget.style.boxShadow = `0 16px 40px ${feature.color}18`
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.borderColor = feature.border
              e.currentTarget.style.boxShadow = '0 1px 6px rgba(0,0,0,0.04)'
            }}
          >
            {/* Corner tint */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                width: '120px',
                height: '120px',
                background: `radial-gradient(circle at top right, ${feature.lightBg} 0%, transparent 70%)`,
                pointerEvents: 'none',
              }}
            />

            <div
              style={{
                width: '52px',
                height: '52px',
                borderRadius: '14px',
                background: feature.lightBg,
                border: `1.5px solid ${feature.border}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: feature.color,
                marginBottom: '20px',
                boxShadow: `0 4px 12px ${feature.color}15`,
              }}
            >
              {feature.icon}
            </div>
            <h3
              style={{
                fontSize: '18px',
                fontWeight: '700',
                color: '#0F172A',
                margin: '0 0 10px',
                letterSpacing: '-0.2px',
              }}
            >
              {feature.title}
            </h3>
            <p
              style={{
                fontSize: '15px',
                color: '#6B7280',
                lineHeight: '1.7',
                margin: 0,
              }}
            >
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}
